import { Map, Set } from "immutable";
import { EMPTY_MAP } from "app/app.constants";

export const UserMapper = {
  initial: () => EMPTY_MAP,
  from: ({ accountName, fullName, userId, mobilePhone, appRoles, ...user }) =>
    Map({
      displayName: fullName,
      id: userId,
      userName: accountName,
      phone: mobilePhone,
      appRoles: Set(appRoles),
      ...user,
    }),
};

export const AppRoleMapper = {
  initial: () => EMPTY_MAP,
  from: appRole => Map(appRole),
};
